import React, { useMemo, useState } from "react";
import { Dialog } from "@material-ui/core";

export function useModal() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => setIsModalOpen(!isModalOpen);

    const closeModal = () => setIsModalOpen(false);

    const Modal = useMemo(() => {
        return ({ children }) =>
            isModalOpen && (
                <Dialog open={isModalOpen} onClose={closeModal}>
                    {children}
                </Dialog>
            );
    }, [isModalOpen]);

    return {
        Modal,
        isModalOpen,
        closeModal,
        toggleModal,
    };
}
